import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { getLocationPath } from 'lib/assets/assets_helpers';
import AssetsActions from 'components/assets/AssetsActions';
import { formatTimeStamp } from 'lib/util';

const AssetsRow = ({
  asset,
  companyId,
  locations,
  permissions,
  subcompanyId,
  handleEnableAsset,
  isLoading,
  handleSendTokenAsign,
  t,
}) => {
  const path = getLocationPath(asset);
  const { indexInteger } = asset;
  let consecutive = '',
    prefix = '';
  if (indexInteger && indexInteger[0]) {
    consecutive = indexInteger[0].number;
    if (asset._prefix) {
      prefix = asset._prefix.value;
    }
  }
  const hasElapsedTimeLimitExceeded = (asignedDate) => {
    // Check if the asigned employee has delay on accepting the asset
    let asigned = new Date(asignedDate);
    let today = new Date();
    let Difference_In_Time = today.getTime() - asigned.getTime();
    // To calculate the no. of days between two dates
    let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    if (Difference_In_Days > 3) {
      return true;
    }

    return false;
  };
  let filtroUno = asset.createdAt.split('T');
  let filtroDos = filtroUno[0].split('-');
  // asset.createdAt = asset.createdAt.split('T')[0]
  let location = window.location.href
  const pathArray = location.split("/");
  return (
    <tr>
      {/* <td>
        <Common.Checkbox
          className="icheckbox_flat-green"
          value={"all"}
          onChange={() => {}}
        />
      </td> */}
      {/* <td className="align-middle">{consecutive}</td> */}
      {/* <td className="align-middle">{prefix}</td> */}
      <td>
          <a href={`/companies/${pathArray[4]}/subcompanies/${pathArray[6]}/assets/${asset.id}/detail`}>{asset.number}</a>
        </td>
      <td className="align-middle">{asset.name}</td>
      <td className="align-middle">
        {asset.createdAt ? filtroDos[2] + '/' + filtroDos[1] + '/' + filtroDos[0] : ''}
      </td>
      <td className="align-middle">{(asset._account && asset._account.name) || '-'}</td>
      <td className="align-middle">{(asset._subaccount && asset._subaccount.name) || '-'}</td>
      <td className="align-middle">{(asset._costCenter && asset._costCenter.name) || '-'}</td>
      <td
        className="align-middle"
        dangerouslySetInnerHTML={{
          __html: path
            .map((p) => locations[p] && locations[p].name)
            .filter((l) => l)
            .join(' <br/> '),
        }}
      />
      <td className="align-middle">
        {(asset._employee && `${asset._employee.name} ${asset._employee.lastname}`) || '-'}
      </td>
      <td
        className={`text-center align-middle 
          ${
            asset._employee == null
              ? 'table-default'
              : asset.validated
              ? 'table-success'
              : hasElapsedTimeLimitExceeded(asset.asignedEmployeeDate)
              ? 'table-danger'
              : 'table-warning'
          }`}
      >
        {asset._employee == null
          ? 'Sin Asignar'
          : asset.validated
          ? 'Aceptado'
          : hasElapsedTimeLimitExceeded(asset.asignedEmployeeDate)
          ? 'Retrasado'
          : 'Por aceptar'}
      </td>
      <td className={classnames('align-middle')}>
        <span
          style={{
            fontSize: '0.8rem',
          }}
          className={classnames({
            'badge badge-success': asset._status && asset._status.key === 'DEPRECIATING',
            'badge badge-secondary':
              asset._status &&
              (asset._status.key === 'NOT_DEPRECIATIONG' ||
                asset._status.key === 'NOT_DEPRECIATING' ||
                asset._status.key === 'IN_CONSTRUCTION'),
          })}
        >
          {t((asset._status && asset._status.value) || '-')}
        </span>
      </td>
      {/* <td className={`text-center align-middle`}>
        {asset._provider ? asset._provider.name : "-"}
      </td> */}
      {/* <td className={`text-center align-middle`}>
        {asset.buyOrder}
      </td> */}
      <td
        className={`text-center align-middle ${asset.disabled ? 'table-danger' : 'table-success'}`}
      >
        {t(asset.disabled ? 'common.yes' : 'common.no')}
      </td>
      <td
        className={`text-center align-middle ${
          asset.hasPendingChanges ? 'table-info' : 'table-default'
        }`}
      >
        {t(asset.hasPendingChanges ? 'common.yes' : 'common.no')}
      </td>
      <td className="text-center align-middle d-flex flex-row">
        <AssetsActions
          asset={asset}
          companyId={companyId}
          canRequestUpdate={permissions['acl.assets.request_update']}
          canEdit={permissions['acl.assets.update']}
          canEnable={permissions['acl.assets.enable']}
          canDisable={permissions['acl.assets.disable']}
          subcompanyId={subcompanyId}
          handleEnableAsset={handleEnableAsset}
          isLoading={isLoading}
          handleSendTokenAsign={handleSendTokenAsign}
        />
      </td>
    </tr>
  );
};

AssetsRow.propTypes = {
  asset: PropTypes.object.isRequired,
  companyId: PropTypes.string.isRequired,
  subcompanyId: PropTypes.string.isRequired,
};

export default translate()(AssetsRow);



// WEBPACK FOOTER //
// src/components/assets/AssetsRow.js